/**
 * 系统管理  教室管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>教室管理</el-breadcrumb-item>
    </el-breadcrumb>-->

    <!--列表-->
    <el-table
      ref="tableBox1"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      :row-key="(row) => { return row.id }"
    >
      <el-table-column type="selection" width="55" align="center" :reserve-selection="true"/>
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="Organizers" label="主办单位名称"/>
      <el-table-column prop="Name" label="培训班名称"/>
      <el-table-column prop="CourseCount" label="课程数"/>
      <el-table-column prop="Organizers" label="主办单位名称"/>
      <el-table-column prop="UserCount" label="报名人数"/>
      <el-table-column prop="StartDate" label="开始日期"/>
      <el-table-column prop="EndDate" label="结束日期"/>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <div style="text-align: right;">
      <el-button type="primary" @click="submitData">确定</el-button>
    </div>

  </div>
</template>

<script>
import { getRoomList, addRoom, editRoom, deleteRoomById } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {timestampToTime} from "../../utils/util";
import {getWlxyList} from "../../api/subjectTree";

export default {
  data() {
    return {
      wlxyList: '',

      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      queryParams: {
        page: 1,
        size: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata()
    },
    // 获取营销渠道列表
    getdata() {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getWlxyList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log('selection  ', selection);
      if (selection.length > 3) {
        this.$message.error('最多只能选择三个');
        this.$refs.tableBox1.clearSelection();
        this.$refs.tableBox1.toggleRowSelection(selection.pop());
      } else {
        this.wlxyList = selection;
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    },

    submitData() {
      if (this.wlxyList.length > 0) {
        this.$emit('wlxyData', this.wlxyList);
      } else {
        this.$message.error('请勾选需要的培训大纲数据...')
      }
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/goods/wlxyList.vue